export enum TiendaSecurityObjects {
    HeaderProfileButton = "TiendaHeaderPerfilBtn",

    LoginRoute = "TiendaLoginUsuarios",
    RegisterRoute = "TiendaRegistracionUsuarios",
    ProfileRoute = "TiendaModuloUsuarios",

    CheckoutResumeRoute = "TiendaCheckoutReanudarUsuarios",
}
